<ion-card class="ion-no-margin ion-margin-top ion-padding">
  <div class="first-row">
    <div class="icon-wrapper">
      <ng-content select="ion-icon, .icon-container"></ng-content>
    </div>

    <div class="text-wrapper">
      <ng-content select=".text"></ng-content>
    </div>
  </div>

  <div class="buttons-wrapper">
    <ng-content select="ion-row.buttons-container"></ng-content>
  </div>
</ion-card>
